import store from '@/store/index';

const Products = () => {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/Products');
};
const ShoppingCart = () => {
  return import(
    /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/ShoppingCart'
  );
};
const Checkout = () => {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/Checkout');
};
const OrderReceipt = () => {
  return import(
    /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/OrderReceipt'
  );
};

const shopRoutes = {
  path: '/shop',
  component: () => {
    return import(/* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/Shop');
  },
  props: true,
  meta: {
    requiresAuth: true,
    requiresFullAccount: true,
    title: 'Shop',
  },
  children: [
    {
      path: '',
      name: 'shop',
      props: true,
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/ProductCategories'
        );
      },
      meta: {
        requiresAuth: false,
        requiresFullAccount: true,
        newSiteRedirect: true,
        title: 'Shop',
      },
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout,
      props: true,
      meta: {
        requiresAuth: true,
        requiresFullAccount: true,
        title: 'Checkout',
      },
      params: {
        checkout: 'checkout',
      },
      beforeEnter(to, from, next) {
        if (store.state?.shop?.cart?.length <= 0) {
          next('/shop');
        } else {
          next();
        }
      },
    },
    {
      path: '/receipt/:id',
      name: 'OrderReceipt',
      component: OrderReceipt,
      props: true,
      meta: {
        requiresAuth: true,
        requiresFullAccount: true,
        title: 'Receipt',
      },
      params: {
        title: 'receipt',
      },
    },
    {
      path: '/shop/cart',
      name: 'ShoppingCart',
      component: ShoppingCart,
      props: true,
      meta: {
        requiresAuth: true,
        requiresFullAccount: true,
        title: 'Cart',
      },
    },
    {
      path: '/shop/:category',
      name: 'Products',
      component: Products,
      props: true,
      meta: {
        requiresAuth: false,
        requiresFullAccount: true,
        newSiteRedirect: true,
      },
    },
    {
      path: '/shop/product/:productId',
      name: 'productDetail',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/ProductDetails'
        );
      },
      props: true,
      meta: {
        requiresAuth: false,
        requiresFullAccount: true,
        newSiteRedirect: true,
      },
    },
    {
      path: '/shop/:category/:filter',
      name: 'ProductsFiltered',
      component: Products,
      props: true,
      meta: {
        requiresAuth: false,
        requiresFullAccount: true,
        newSiteRedirect: true,
      },
    },
    {
      path: '/shop/:category/product/:productId',
      name: 'productDetails',
      component: () => {
        return import(
          /* webpackPrefetch: true */ /* webpackChunkName: "shopPages" */ '@/views/ProductDetails'
        );
      },
      props: true,
      meta: {
        requiresAuth: false,
        requiresFullAccount: true,
        newSiteRedirect: true,
      },
    },
  ],
};

export { shopRoutes };
